import request from "./client";

export const searchCustomerByNumber = async ({ number }) => {
  const query = new URLSearchParams({ number }).toString();
  try {
    const resp = await request.get(`/v1/erp/sqlbase/customers?${query}`);
    const body = resp.body;
    return { total: body.total, data: body.data, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};

export const getCustomerAddress = async (customerId) => {
  const resp = await request.get(`/v1/erp/sqlbase/customers/${customerId}/address`);
  return resp.body;
};

export const getCustomerProperties = async (customerId) => {
  const resp = await request.get(`/v1/erp/sqlbase/customers/${customerId}/properties`);
  return resp.body;
};

export const getCustomerContacts = async (customerId) => {
  const resp = await request.get(`/v1/erp/sqlbase/customers/${customerId}/contacts`);
  return resp.body;
};

export const getCustomerCommunications = async (customerId) => {
  const resp = await request.get(`/v1/erp/sqlbase/customers/${customerId}/communications`);
  return resp.body;
};

export const getPropertyAddress = async (propertyId) => {
  const resp = await request.get(`/v1/erp/sqlbase/properties/${propertyId}/address`);
  return resp.body;
};

export const getPropertyContacts = async (propertyId) => {
  const resp = await request.get(`/v1/erp/sqlbase/properties/${propertyId}/contacts`);
  return resp.body;
};

export const getPropertyCommunications = async (propertyId) => {
  const resp = await request.get(`/v1/erp/sqlbase/properties/${propertyId}/communications`);
  return resp.body;
};

export const searchAddressByStreet = async ({ street, city = "", country = "", limit = 5 }) => {
  const query = new URLSearchParams({
    street,
    limit,
    ...(city && { city }),
    ...(country && { country }),
  }).toString();
  try {
    const resp = await request.get(`/v1/search/address?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};
